<template>
  <div style="width: 100%">
    <mentorship-employee v-if="me" :id="+me.id" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import MentorshipEmployee from "@/components/mentorship/MentorshipEmployee.vue";

export default {
  components: {
    MentorshipEmployee,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["me"]),
  },
  methods: {},
};
</script>
